import type { ProductListParams } from '../api/products-api';

/** Query key factory for the organisation master catalog. Sub-resources hang off the detail key. */
export const productKeys = {
  all: ['org', 'products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (params: ProductListParams) => [...productKeys.lists(), params] as const,
  // Under `lists()`: whatever refreshes the rows refreshes their health counts.
  health: () => [...productKeys.lists(), 'health'] as const,
  vendors: () => [...productKeys.all, 'vendors'] as const,
  vendorSearch: (q: string) => [...productKeys.vendors(), q] as const,
  details: () => [...productKeys.all, 'detail'] as const,
  detail: (productId: string) => [...productKeys.details(), productId] as const,
  variants: (productId: string) => [...productKeys.detail(productId), 'variants'] as const,
  media: (productId: string) => [...productKeys.detail(productId), 'media'] as const,
  relations: (productId: string) => [...productKeys.detail(productId), 'relations'] as const,
  configurator: (productId: string) => [...productKeys.detail(productId), 'configurator'] as const,
  skuPreview: (productId: string, includeManual: boolean) =>
    [...productKeys.detail(productId), 'sku-preview', { includeManual }] as const,
  skuHistory: (productId: string) => [...productKeys.detail(productId), 'sku-history'] as const,
};

/** SKU rules are organisation-level; the products feature only resolves one for a product type. */
export const skuRuleKeys = {
  all: ['org', 'sku-rules'] as const,
  resolve: (productTypeId: string | null) =>
    [...skuRuleKeys.all, 'resolve', productTypeId] as const,
};
